/**
 * the replace function callback
 */
type t_replace_fn = (match: string, index: number, s: string) => string;
type t_replace_es5_fn = (substring: string, ...args: unknown[]) => string;

/**
 * @packageDocumentation
 * @module f1/string
 */

export interface Replace {
  /**
   * Search for sub-strings and invoke a method to alter each sub-string, placing
   * the new value back in the string
   *
   * @public
   * @function f1.replace
   * @param search the search rule to apply
   * @param replacer the method to alter each string with (or a string)
   * @param s any string
   * @example
   *
   * ```ts
   * f1.replace('a', (s) => `-${s}-`, 'bcdadcb') === 'bcd-a-dcb'
   * ```
   */
  (search: string | RegExp, replacer: string | t_replace_fn, s: string): string;
  (search: string | RegExp, replacer: string | t_replace_fn): (s: string) => string;
}

/**
 * @see Replace
 */
export default (search: string | RegExp, replacer: string | t_replace_fn, s: string) => {
  return s.replace(search, (replacer as unknown) as t_replace_es5_fn);
};
